import * as sup from 'superstruct';

import {
  createIdentifierStruct,
  createResourceStruct,
  createResponseStruct,
} from '@/modules/api/utils/jsonApiStructs';
import { NegotiationTermRole } from '@/modules/negotiation/types/negotiationTypes';

const getDemoNegotiationsMetricsResource = createResourceStruct({
  identifier: createIdentifierStruct('customer_demo_metrics'),
  attributes: sup.object({
    suppliersCount: sup.number(),
    currentSpend: sup.number(),
    potentialSavings: sup.number(),
    potentialCostAvoidance: sup.number(),
    terms: sup.record(
      sup.enums(Object.values(NegotiationTermRole)),
      sup.object({ potentialCount: sup.number() })
    ),
  }),
});

export const getDemoNegotiationsMetricsResponseStruct = createResponseStruct({
  data: getDemoNegotiationsMetricsResource,
});

export type GetDemoNegotiationMetricsResponse = sup.Infer<
  typeof getDemoNegotiationsMetricsResponseStruct
>;
